angular.module('impactx.cube').service('CatApprovalService', CatalogApprovalService);

CatalogApprovalService.$inject = ['dataGen', '$mdToast', 'ToastService', '$mdDialog'];

function CatalogApprovalService(dataGen, $mdToast, ToastService, $mdDialog) {
    this.approveCatalogs = function(atiIds, callback, ev) {
        return $mdDialog.show({
            controller: 'CatalogActionDialogCtrl',
            controllerAs: 'catalogActionDialogCtrl',
            templateUrl: 'modules/catalog/templates/catalogaction.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                catId: 0,
                atiIds: atiIds,
                action: 'approve'
            }
        }).then(function(answer) {
            var vm = {};
            return dataGen.postAsForm(vm, {
                atiIds: atiIds,
                approveDate: answer.actionDate,
                comment: answer.comment
            }, "/catalog/approve").then(function () {
                ToastService.openStandardToast(vm.data.success);
                if (callback) {
                    callback();
                }
            });
        });
    };

    this.denyCatalogs = function(atiIds, callback, ev) {
        return $mdDialog.show({
            controller: 'CatalogActionDialogCtrl',
            controllerAs: 'catalogActionDialogCtrl',
            templateUrl: 'modules/catalog/templates/catalogaction.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                catId: 0,
                atiIds: atiIds,
                action: 'deny'
            }
        }).then(function(answer) {
            var vm = {};
            return dataGen.postAsForm(vm, {atiIds: atiIds, comment: answer.comment}, "/catalog/deny").then(function () {
                ToastService.openStandardToast(vm.data.success ? vm.data.success : vm.trns.denySuccess);
                if (callback) {
                    callback();
                }
            });
        });
    };

    this.denyCatalogDialog = function(catId, callback, ev)
    {
        return $mdDialog.show({
            controller: 'CatalogActionDialogCtrl',
            controllerAs: 'catalogActionDialogCtrl',
            templateUrl: 'modules/catalog/templates/catalogaction.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                catId: catId,
                atiIds: null,
                action: 'discard'
            }
        }).then(function(answer) {
            var dataObj = {
                cat: {
                    id: catId,
                    approvalComment: answer.comment
                }
            };
            var vm = {};
            dataGen.postAsForm(vm, dataObj, "/catalog/denydialog").then(function () {
                ToastService.openStandardToast(vm.trns.denySuccess);
                if (callback) {
                    callback();
                }
            });
        });
    };

    this.stopCatalog = function(catId, callback, ev) {
        return $mdDialog.show({
            controller: 'CatalogActionDialogCtrl',
            controllerAs: 'catalogActionDialogCtrl',
            templateUrl: 'modules/catalog/templates/catalogaction.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                catId: catId,
                atiIds: null,
                action: 'stop'
            }
        }).then(function(answer) {
            var vm = {};
            var dataObj = {
                cat: {
                    id: catId,
                    approvalComment: answer.comment
                }
            };
            return dataGen.postAsForm(vm, dataObj, "/catalog/stop").then(function() {
                ToastService.openStandardToast(vm.data.success ? vm.data.success : vm.trns.stopSuccess);
                if(callback) {
                    callback();
                }
            })
        });
    };

    this.forwardToApproval = function(catId, callback, ev) {
        return $mdDialog.show({
            controller: 'CatalogActionDialogCtrl',
            controllerAs: 'catalogActionDialogCtrl',
            templateUrl: 'modules/catalog/templates/catalogaction.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                catId: catId,
                atiIds: null,
                action: 'forward'
            }
        }).then(function(answer) {
            var dataObj = {
                cat: {
                    id: catId,
                    approvalComment: answer.comment,
                    plannedRelease: answer.actionDate
                }
            };
            var vm = {};
            dataGen.postAsForm(vm, dataObj, "/catalog/doneforward").then(function () {
                ToastService.openStandardToast(vm.trns.forwardSuccess);
                if (callback) {
                    callback();
                }
            });
        });
    };

    this.checkInAndForwardToApproval = function(catId, successCallback, failCallback, ev) {
        return $mdDialog.show({
            controller: 'CatalogActionDialogCtrl',
            controllerAs: 'catalogActionDialogCtrl',
            templateUrl: 'modules/catalog/templates/catalogaction.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                catId: catId,
                atiIds: null,
                action: 'checkinforward'
            }
        }).then(function(answer) {
            var vm = {};
            var dataObj = {
                cat: {
                    id: catId,
                    approvalComment: answer.comment,
                    plannedRelease: answer.actionDate
                }
            };
            dataGen.postAsForm(vm, dataObj, "/catalog/checkinandmoveforward").then(function () {
                ToastService.openStandardToast(vm.trns.forwardMessage);
                if (successCallback) {
                    successCallback();
                }
            }, function () {
                if (failCallback) {
                    failCallback();
                }
            });
        });
    };

    this.release = function (catId, callback, event)
    {
        $mdDialog.show({
            controller: "CatalogActionDialogCtrl",
            controllerAs: "catalogActionDialogCtrl",
            templateUrl: "modules/catalog/templates/catalogaction.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                catId: catId,
                atiIds: null,
                action: 'release'
            }
        }).then(function(answer) {
            var dataObj = {
                cat: {
                    id: catId,
                    plannedRelease: answer.actionDate,
                    approvalComment: answer.comment
                }
            };
            var vm = {};
            dataGen.postAsForm(vm, dataObj, "/catalog/release").then(function ()
            {
                ToastService.openStandardToast(vm.trns.releaseSuccess);
                if(callback){
                    callback();
                }
            });

        });
    };
}
